import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section id="inicio" className="relative min-h-screen flex items-center pt-32 pb-16 overflow-hidden" data-id="element-193">
      {/* Fondos */}
      <div className="absolute top-[20%] left-[-10%] w-[500px] h-[500px] bg-[#00D4FF]/10 rounded-full blur-[120px] z-0" data-id="element-194" />
      <div className="absolute bottom-[20%] right-[-10%] w-[400px] h-[400px] bg-[#1D4ED8]/10 rounded-full blur-[100px] z-0" data-id="element-195" />

      {/* CONTENEDOR PRINCIPAL */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 flex flex-col lg:flex-row items-center justify-between gap-12 lg:gap-16" data-id="element-196">
        {/* ═══════════════════════
            COLUMNA IZQUIERDA
         ═══════════════════════ */}
        <div className="w-full lg:w-1/2 flex flex-col items-center lg:items-start text-center lg:text-left pt-8 lg:pt-0" data-id="element-197">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white leading-tight mb-6" data-id="element-198">
            Tu Negocio Merece una Página Web que{' '}
            <span className="bg-gradient-to-r from-[#00D4FF] to-[#60EFFF] text-transparent bg-clip-text" data-id="element-199">
              Trabaje Por Ti
            </span>{' '}
            las 24 Horas
          </h1>

          <p className="text-lg sm:text-xl text-[#A0AEC0] leading-relaxed mb-10 max-w-2xl" data-id="element-200">
            Diseñamos páginas web y landing pages profesionales para negocios
            locales que quieren crecer en internet. Sin complicaciones. Sin
            tecnicismos. Solo resultados.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 w-full sm:w-auto" data-id="element-201">
            <a href="#contacto" className="w-full sm:w-auto text-center bg-gradient-to-br from-[#00D4FF] to-[#0080FF] text-black px-8 py-4 rounded-full font-extrabold text-base shadow-[0_8px_32px_rgba(0,212,255,0.3)] hover:shadow-[0_8px_32px_rgba(0,212,255,0.5)] hover:scale-105 transition-all duration-300" data-id="element-202">
              COTIZAR AHORA
            </a>
            <a href="#portafolio" className="w-full sm:w-auto text-center text-white px-8 py-4 rounded-full font-bold text-base border-2 border-[#00D4FF]/50 hover:bg-[#00D4FF]/10 transition-all duration-300" data-id="element-203">
              VER PORTAFOLIO
            </a>
          </div>
        </div>

        {/* ═══════════════════════
            COLUMNA DERECHA
         ═══════════════════════ */}
        <div className="w-full lg:w-1/2 relative flex justify-center items-center mt-8 lg:mt-0" data-id="element-204">
          {/* Glow */}
          <div className="absolute w-[80%] h-[80%] bg-[#00D4FF]/10 rounded-full blur-[70px] z-0 top-[10%]" data-id="element-205" />

          {/* IMAGEN */}
          <motion.div className="relative z-10 w-full max-w-[600px]" animate={{
          y: [0, -15, 0]
        }} transition={{
          repeat: Infinity,
          duration: 4,
          ease: 'easeInOut'
        }} data-id="element-206">
            <img src="https://cdn.magicpatterns.com/uploads/p8PubZ3CpF2y2jsVq3UDgT/Ultra-realistic_professional_p_Nano_Banana_2_45959.png" alt="Diseño Web Profesional" className="w-full h-auto rounded-2xl shadow-[0_20px_50px_rgba(0,0,0,0.5)] border border-white/10" data-id="element-207" />

            {/* Badge Diseño Pro */}
            <div className="absolute -top-4 -right-4 z-20 bg-gradient-to-br from-[#00D4FF] to-[#0050FF] rounded-full px-4 py-2 text-xs text-white font-bold shadow-[0_8px_24px_rgba(0,212,255,0.5)] border border-white/25 hidden sm:block" data-id="element-208">
              ⚡ Diseño Pro
            </div>

            {/* Badge Página lista */}
            <div className="absolute -bottom-4 -left-4 z-20 bg-[#0C0C18] border border-[#00D4FF]/30 rounded-full px-4 py-2 text-xs text-white/70 shadow-[0_8px_24px_rgba(0,0,0,0.5)] flex items-center gap-2 hidden sm:flex" data-id="element-209">
              <div className="w-2 h-2 rounded-full bg-[#4ADE80]" data-id="element-210" />
              Página lista en 7 días
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}